import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function ArrowIcon() {
    return (
        <SvgIcon viewBox="0 0 287.15 285.62">
            <path
                fill="none"
                fillRule="evenodd"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="9"
                d="M255.02,27.45s29.41,44.94-1.14,73.31c-67.74,62.89-82.9-9.73-68.86-24.31,30.32-31.49,74.84,11.82,57,79-17.82,67.12-120.2,39.6-130.54-5.95-10.5-46.25,78.77-44.84,60.43,2.38-16.11,41.5-94.53,77.16-94.53,77.16l21.36,18.38-64.72,26.02,23.14-61.39,25.59,21.62"
            />
        </SvgIcon>
    );
}

export default ArrowIcon;
